import $http from '@/utils/httpRequest'
export default {
    namespaced: true,
    state:{
        regionTreeList:[],
        placeTypeList:[],
        supportingList:[],
        businessTypeList:[],
        secrecyStatusList:[],
        applyTypeList:[],
        applyTimeIntervalList:[],
        fieldBusClass:[],
        fieldLinks:[],
        tradeOrgList:[],
        setimerules:[]
    },
    actions:{
        getRegionTree({commit},extendNodeName){
            $http.get('/base/region/getRegionTree?parentCode='+process.env.VUE_APP_REGION+'&extendNodeName='+extendNodeName)
                .then(res=>{
                    commit('setRegionTree',res.data.data[0].children)
                })
        },
        getPlaceType({commit},extendNodeName){
            $http.get('/base/dictData/findDictDataListByTypeCode?type=105&extendNodeName='+extendNodeName)
                .then(res=>{
                    commit('setPlaceType',res.data.data)
                })
        },
        getSupportingList({commit}){
            $http.get('/base/dictData/findDictDataListByTypeCode?type=158')
                .then(res=>{
                    commit('setSupportingList',res.data.data)
                })
        },
        getBusinessTypeList({commit}){
            $http.get('/base/dictData/findDictDataListByTypeCode?type=field_bustype')
                .then(res=>{
                    commit('setBusinessTypeList',res.data.data)
                })
        },
        getSecrecyStatusList({commit}){
            $http.get('/base/dictData/findDictDataListByTypeCode?type=field_secrecy_status')
                .then(res=>{
                    commit('setSecrecyStatusList',res.data.data)
                })
        },
        getApplyTypeList({commit}){
            $http.get('/base/dictData/findDictDataListByTypeCode?type=field_apply_type')
                .then(res=>{
                    commit('setApplyTypeList',res.data.data)
                })
        },
        getApplyTimeIntervalList({commit}){
            $http.get('/base/dictData/findDictDataListByTypeCode?type=108')
                .then(res=>{
                    commit('setApplyTimeIntervalList',res.data.data)
                })
        },
        getFieldBusClass({commit}){
            $http.get('/base/dictData/findDictDataListByTypeCode?type=field_busclass')
                .then(res=>{
                    commit('setFieldBusClass',res.data.data)
                })
        },
        getFieldLinks({commit}){
            $http.get('/field/apply/getFieldLinks')
                .then(res=>{
                    commit('setFieldLinks',res.data.data)
                })
        },
        getSetimerules({commit}){
            $http.post('/config/setimerules')
                .then(res=>{
                    commit('setSetimerules',res.data.data)
                })
        },
        getTradeOrgList({commit}){
            $http.post('/config/loadTrades?regionCode='+process.env.VUE_APP_REGION)
                .then(res=>{
                    commit('setTradeOrgList',res.data.data)
                })
        },
        
        
    },
    mutations:{
        setRegionTree(state,data){
            state.regionTreeList = data;
        },
        setTradeOrgList(state,data){
            state.tradeOrgList = data;
        },
        setPlaceType(state,data){
            state.placeTypeList = data;
        },
        setSupportingList(state,data){
            state.supportingList = data;
        },
        setBusinessTypeList(state,data){
            state.businessTypeList=data;
        },
        setSecrecyStatusList(state,data){
            state.secrecyStatusList=data;
        },
        setApplyTypeList(state,data){
            state.applyTypeList=data;
        },
        setApplyTimeIntervalList(state,data){
            state.applyTimeIntervalList=data;
        },
        setFieldBusClass(state,data){
            state.fieldBusClass=data;
        },
        setFieldLinks(state,data){
            state.fieldLinks=data;
        },
        setSetimerules(state,data){
            state.setimerules=data;
        },
    },
}